<template>
    <div class="printManagementListClass">
        <div class="searchPart">
            <el-select v-model="materialTypeValue" placeholder="材料分类">
                <el-option
                    label="全部"
                    value="全部">
                </el-option>
                <el-option
                    label="高分子材料"
                    value="高分子材料">
                </el-option>
                <el-option
                    label="金属"
                    value="金属">
                </el-option>
                <el-option
                    label="无机非金属"
                    value="无机非金属">
                </el-option>
            </el-select>
            <el-input v-model="materialNameValue" placeholder="材料名称"></el-input>
            <el-input v-model="materialNumberValue" placeholder="材料编号"></el-input>
            <el-button class="searchBtn">搜索</el-button>
            <el-button type="text" class="resetBtn" @click="reset">
                <i class="iconfont icon-qingchushujuku"></i>
                <span>清除条件</span>
            </el-button>
        </div>
        <div class="tablePart">
            <div class="tableTool">
                <div class="toolLeft">
                    <span>已选： <span class="num">{{multipleSelection.length}}</span></span>
                    <el-button type="primary" plain size="small">批量删除</el-button>
                    <el-button type="primary" plain size="small">批量发布</el-button>
                </div>
                <div class="toolRight">
                    <el-button type="primary" size="small" @click="toDialog('add')"><i
                        class="el-icon-circle-plus-outline"></i>添加
                    </el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                style="width: 100%" @selection-change="handleSelectionChange" class="tableContent">
                <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="缩略图"
                    header-align="center"
                    align="center"
                    width="170">
                    <template slot-scope="scope">
                        <img :src="scope.row.img" alt="">
                    </template>
                </el-table-column>
                <el-table-column
                    prop="materialType"
                    label="材料分类"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="材料名称"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="processType"
                    label="工艺类型"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    align="center"
                    header-align="center"
                    label="单价" width="200">
                    <template slot-scope="scope">
                        {{scope.row.price}}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    header-align="center"
                    label="发货周期" width="160">
                    <template slot-scope="scope">
                        {{scope.row.period}}天
                    </template>
                </el-table-column>
                <el-table-column
                    prop="state"
                    label="状态"
                    header-align="center"
                    align="center"
                    width="110">
                </el-table-column>
                <el-table-column
                    prop="sort"
                    label="排序"
                    header-align="center"
                    align="center"
                    width="110">
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230">
                    <template slot-scope="scope">
                        <el-button type="text" size="small">发布</el-button>
                        <el-button type="text" size="small" @click="toDialog('edit')">编辑</el-button>
                        <el-button type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total,prev, pager, next,jumper"
                :page-size="10"
                :total="1000" class="pagination">
            </el-pagination>
        </div>
        <material-management-dialog ref="dialogRef"></material-management-dialog>
    </div>
</template>

<script>
    import materialManagementDialog from './materialManagementDialog'
    
    export default {
        data() {
            return {
                materialTypeValue: '',
                materialNameValue: '',
                materialNumberValue: '',
                tableData: [
                    {
                        img: require('@/assets/images/materialImg.png'),
                        materialType: '树脂-进口光敏树脂',
                        sort: '1',
                        name: '进口光敏树脂',
                        processType: 'DLP',
                        price: '￥3元/克',
                        period: '3-5',
                        state: '审核中'
                    }, {
                        img: require('@/assets/images/materialImg.png'),
                        materialType: '树脂-进口光敏树脂',
                        sort: '2',
                        name: '进口光敏树脂',
                        processType: 'DLP',
                        price: '￥3元/克',
                        period: '3-5',
                        state: '审核中'
                    }, {
                        img: require('@/assets/images/materialImg.png'),
                        materialType: '树脂-进口光敏树脂',
                        sort: '3',
                        name: '进口光敏树脂',
                        processType: 'DLP',
                        price: '￥3元/克',
                        period: '3-5',
                        state: '审核中'
                    }, {
                        img: require('@/assets/images/materialImg.png'),
                        materialType: '树脂-进口光敏树脂',
                        sort: '4',
                        name: '进口光敏树脂',
                        processType: 'DLP',
                        price: '￥3元/克',
                        period: '3-5',
                        state: '审核中'
                    }],
                multipleSelection: []
            }
        },
        components: {
            materialManagementDialog
        },
        methods: {
            // 清除检索条件
            reset() {
                this.materialTypeValue = ''
                this.materialNameValue = ''
                this.materialNumberValue = ''
            },
            // 复选框选中值
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            // 编辑/新增
            toDialog(type) {
                this.$refs.dialogRef.init(type)
            }
        }
    }
</script>

<style scoped lang="less">
    .printManagementListClass {
        padding: 20px;
        
        .searchPart {
            display: flex;
            flex-wrap: wrap;
            
            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }
            
            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;
                
                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }
            
            /deep/ .el-input__prefix {
                top: -3px;
            }
            
            /deep/ .el-input__suffix {
                top: 2px;
            }
            
            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }
            
            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom:22px;
            }
            
            .resetBtn {
                color: #333333;
                margin-bottom:22px;
            }
        }
        
        .tablePart {
            .tableTool {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
                
                .toolLeft {
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.847);
                    
                    .num {
                        color: #356FDF;
                    }
                    
                    button {
                        padding: 0;
                        margin-left: 15px;
                        width: 80px;
                        height: 30px;
                        background: rgba(242, 244, 247, 1);
                        box-sizing: border-box;
                        border: 1px solid rgba(21, 126, 251, 1);
                        border-radius: 5px;
                        font-size: 12px;
                        color: #157EFB;
                        line-height: 30px;
                        text-align: center;
                        
                        &:hover {
                            background: #157EFB;
                            box-sizing: border-box;
                            border: 1px solid #157EFB;
                            color: #fff;
                        }
                    }
                }
                
                .toolRight {
                    button {
                        width: 83px;
                        height: 30px;
                        background: rgba(21, 126, 251, 1);
                        border: none;
                        border-radius: 15px;
                        font-size: 13px;
                        color: #fff;
                        
                        i {
                            padding-right: 5px;
                        }
                        
                        &:hover {
                            background: #61a2f0;
                        }
                    }
                }
            }
            
            .tableContent {
                min-height: 650px;
                
                /deep/ .el-table__header {
                    tr {
                        th {
                            border-right: none;
                        }
                    }
                    
                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }
                
                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }
                    
                    /deep/ .el-table__row {
                        td:first-child {
                            border-right: none;
                            
                            .cell {
                                padding-left: 15px;
                            }
                        }
                    }
                }
            }
            
            .pagination {
                margin-top: 20px;
                text-align: right;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/commodity/printManagement/materialManagement.vue